import { help, name, portfolio, node, settings } from "../../../utils";
import ChatSelector from "./LayoutSections/ChatSelector/ChatSelector";
import HelpSection from "./LayoutSections/HelpSection/HelpSection";
import "./Layout.css"
import React, {useState, useEffect, useMemo} from "react";
import {useAppContext} from "../../../AppDataContext";
import {bot,bot_logo} from "../../../utils";
export interface layoutProps {
  logourl?: string,
  badgeurl?: string,
  startNewChat?: () => void
  collapsed?: boolean
   handleToggle?: (newState?: boolean) => void; // Add this line to accept the toggle function
}
const Layout:React.FC<layoutProps> = ({logourl, startNewChat,collapsed ,handleToggle}) => {
const appContext = useAppContext();
    const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 600);

    // Update isMobileView state based on window size
  const handleResize = () => {
    setIsMobileView(window.innerWidth <= 600);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Click handler for the navigation
  const handleClick = () => {
  if (isMobileView) {
    if (handleToggle) {
      handleToggle(); // Call the handleToggle function
    }
  }
  };
    const imageSrcbadgeUrl = useMemo(() => {
       if(appContext.badgeurl && appContext.badgeurl.toLowerCase().startsWith('http'))
            return appContext.badgeurl;
           const badgeUrlValue = bot[appContext.badgeurl as keyof typeof bot];
    if (Array.isArray(badgeUrlValue)) {
        const dynamicThemelogoUrl = badgeUrlValue.find(url => url.includes(sessionStorage.getItem('userTheme')));
        return dynamicThemelogoUrl ? dynamicThemelogoUrl : badgeUrlValue[0];
    }
        return appContext.badgeurl && bot[appContext.badgeurl as keyof typeof bot] ? bot[appContext.badgeurl as keyof typeof bot] : bot.default;
    }, [appContext.badgeurl]);

        const imageSrclogoUrl = useMemo(() => {
          if(appContext.logourl && appContext.logourl.toLowerCase().startsWith('http'))
            return appContext.logourl;
            const logoUrlValue = bot_logo[appContext.logourl as keyof typeof bot_logo];
            if (Array.isArray(logoUrlValue)) {
                const dynamicThemelogoUrl = logoUrlValue.find(url => url.includes(sessionStorage.getItem('userTheme')));
                return dynamicThemelogoUrl ? dynamicThemelogoUrl : logoUrlValue[0];
            }
        return appContext.logourl && bot_logo[appContext.logourl as keyof typeof bot_logo] ? bot_logo[appContext.logourl as keyof typeof bot_logo] : bot_logo.default;
    }, [appContext.logourl]);
  return (
    <section>
      <div className={`nav ${collapsed ? 'collapsed' : ''}`}>
        <div className={`overlaychat ${collapsed ? 'collapsed' : ''}`} onClick={handleClick}></div>
        <div className={`navigation ${collapsed ? 'collapsed' : ''}`}>
            <div className={`nav__logo ${collapsed ? 'collapsed' : ''}`}
                 style={logourl && logourl !== "none" ?
                         {backgroundImage: `url(${!collapsed ? imageSrclogoUrl : imageSrcbadgeUrl})` ,height: !collapsed ? "" : "80px" } : {}}
                 onClick={handleClick}></div>
          <ChatSelector startNewChat={startNewChat} collapsed={!!collapsed}/>
        </div>
        <div className={`options ${collapsed ? 'collapsed' : ''}`}>
          <div>
            <HelpSection imageSrc={portfolio} title={"My Portfolio"}/>
            <HelpSection imageSrc={node} title={"My Market POV"}/>
          </div>
          <div className="nav__bottomTabs">
            <HelpSection imageSrc={settings} title={"Settings"}/>
            <HelpSection imageSrc={help} title={"Help?"}/>
            <HelpSection imageSrc={name} title={"Andrew Hgine"} profile={"AR"}/>
          </div>
        </div>
      </div>

    </section>
  );
};

export default Layout;